/*
 * @Author: Teemo Ding
 * @Date: 2022-05-09 10:57:39
 * @LastEditTime: 2022-05-11 14:59:12
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportingDashboard/Components/LineChartItem/index.tsx
 */
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import Link from '@/src/components/Link/Link';
import { max, toNumber } from 'lodash';
import React from 'react';
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
interface ILines {
  [key: string]: { color: string; label: string };
}

interface ITotal {
  [key: string]: string;
}

interface IProps {
  data: any[];
  lines: ILines;
  title: string;
  totalList?: ITotal;
  yAxisTitle: string;
  viewReportUrl: string;
  formatPrice?: (value: string) => string;
  tickFormatter?: (value: string | number) => string;
}

const LineChartItem = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    data,
    lines,
    title,
    totalList,
    yAxisTitle,
    viewReportUrl,
    formatPrice,
    tickFormatter,
  } = props;
  // const d = [
  //   {
  //     dateTime: '2024-07-22',
  //     orderCreatedAmount: '2,302.125',
  //     orderPaidAmount: '1,579.125',
  //     orderCreatedCount: '7',
  //     orderPaidCount: '4',
  //     returningCustomerOrderAmount: '1,579.125',
  //     newCustomerOrderAmount: '0',
  //     guestCheckoutOrderAmount: '0',
  //     returningCustomerOrderCount: '4',
  //     newCustomerOrderCount: '0',
  //     guestCheckoutOrderCount: '0',
  //   },
  //   {
  //     dateTime: '2024-07-23',
  //     orderCreatedAmount: '1,507.800',
  //     orderPaidAmount: '1,507.800',
  //     orderCreatedCount: '4',
  //     orderPaidCount: '4',
  //     returningCustomerOrderAmount: '1,507.800',
  //     newCustomerOrderAmount: '0',
  //     guestCheckoutOrderAmount: '0',
  //     returningCustomerOrderCount: '4',
  //     newCustomerOrderCount: '0',
  //     guestCheckoutOrderCount: '0',
  //   },
  //   {
  //     dateTime: '2024-07-24',
  //     orderCreatedAmount: '1,756.554',
  //     orderPaidAmount: '1,600.554',
  //     orderCreatedCount: '7',
  //     orderPaidCount: '6',
  //     returningCustomerOrderAmount: '1,600.554',
  //     newCustomerOrderAmount: '0',
  //     guestCheckoutOrderAmount: '0',
  //     returningCustomerOrderCount: '6',
  //     newCustomerOrderCount: '0',
  //     guestCheckoutOrderCount: '0',
  //   },
  //   {
  //     dateTime: '2024-07-25',
  //     orderCreatedAmount: '3,812.324',
  //     orderPaidAmount: '3,812.324',
  //     orderCreatedCount: '4',
  //     orderPaidCount: '4',
  //     returningCustomerOrderAmount: '3,812.324',
  //     newCustomerOrderAmount: '0',
  //     guestCheckoutOrderAmount: '0',
  //     returningCustomerOrderCount: '4',
  //     newCustomerOrderCount: '0',
  //     guestCheckoutOrderCount: '0',
  //   },
  //   {
  //     dateTime: '2024-07-26',
  //     orderCreatedAmount: '3,002.000',
  //     orderPaidAmount: '2,292.000',
  //     orderCreatedCount: '6',
  //     orderPaidCount: '4',
  //     returningCustomerOrderAmount: '2,163.000',
  //     newCustomerOrderAmount: '129.000',
  //     guestCheckoutOrderAmount: '0',
  //     returningCustomerOrderCount: '3',
  //     newCustomerOrderCount: '1',
  //     guestCheckoutOrderCount: '0',
  //   },
  //   {
  //     dateTime: '2024-07-27',
  //     orderCreatedAmount: '0',
  //     orderPaidAmount: '0',
  //     orderCreatedCount: '0',
  //     orderPaidCount: '0',
  //     returningCustomerOrderAmount: '0',
  //     newCustomerOrderAmount: '0',
  //     guestCheckoutOrderAmount: '0',
  //     returningCustomerOrderCount: '0',
  //     newCustomerOrderCount: '0',
  //     guestCheckoutOrderCount: '0',
  //   },
  //   {
  //     dateTime: '2024-07-28',
  //     orderCreatedAmount: '0',
  //     orderPaidAmount: '0',
  //     orderCreatedCount: '0',
  //     orderPaidCount: '0',
  //     returningCustomerOrderAmount: '0',
  //     newCustomerOrderAmount: '0',
  //     guestCheckoutOrderAmount: '0',
  //     returningCustomerOrderCount: '0',
  //     newCustomerOrderCount: '0',
  //     guestCheckoutOrderCount: '0',
  //   },
  //   {
  //     dateTime: '2024-07-29',
  //     orderCreatedAmount: '0',
  //     orderPaidAmount: '0',
  //     orderCreatedCount: '0',
  //     orderPaidCount: '0',
  //     returningCustomerOrderAmount: '0',
  //     newCustomerOrderAmount: '0',
  //     guestCheckoutOrderAmount: '0',
  //     returningCustomerOrderCount: '0',
  //     newCustomerOrderCount: '0',
  //     guestCheckoutOrderCount: '0',
  //   },
  // ];
  const nd = data.map((i) => {
    const n = {};
    Object.keys(i).forEach((k) => {
      const nV = i[k].replaceAll(',', '');
      n[k] = nV;
    });
    return n;
  });

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className={css.customTooltip}>
          <p className={css.time}>{label}</p>
          {Object.entries(lines).map((item, index) => {
            return (
              <p className={css.label} key={index}>
                <span
                  className={css.color}
                  style={{ backgroundColor: item[1].color }}></span>
                {item[1].label} :{' '}
                <span className={css.value}>
                  {formatPrice
                    ? formatPrice(payload[index].value)
                    : payload[index].value}
                </span>
              </p>
            );
          })}
        </div>
      );
    }
    return null;
  };

  // 找最大值
  const dataAll = data.flatMap((dataItem) => {
    return Object.entries(lines).map((item) => {
      const replaceQuote = (dataItem[item[0]] || '').replaceAll(',', '');
      return toNumber(replaceQuote);
    });
  });
  const maxValue: number = max(dataAll);

  return (
    <div className={css.contain}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.containerClassName}
        rightPart={
          <Link className={css.viewReport} to={viewReportUrl}>
            {getI18n('dashboard.innercomponents.lineChartItem.viewreports')}
          </Link>
        }
        title={title}>
        <div className={css.totalContain}>
          {Object.entries(totalList).map((item, index) => {
            return (
              <div key={index} className={css.total}>
                <div className={css.label}>{item[0]}</div>
                <div className={css.value}>{item[1]}</div>
              </div>
            );
          })}
        </div>
        <div className={css.chartTitle}>{yAxisTitle}</div>
        <ResponsiveContainer width='100%' height={400} minWidth={300}>
          <LineChart
            // width={500}
            data={nd}
            margin={{
              top: 16,
              right: 32,
              left: 32,
              bottom: 5,
            }}>
            <CartesianGrid stroke='#EEEEEE' strokeDasharray='5 5' />
            <XAxis
              dataKey='dateTime'
              axisLine={true}
              tickMargin={10}
              interval='preserveStart'
            />

            <YAxis
              type='number'
              domain={maxValue > 0 ? [0, maxValue] : [0, 'auto']}
              tickFormatter={tickFormatter}
              axisLine={false}
              tick={{ stroke: '#8C9196', strokeWidth: 1 }}
            />
            <Tooltip content={CustomTooltip} />
            {Object.entries(lines).map((item) => {
              return (
                <Line
                  key={item[0]}
                  dataKey={item[0]}
                  stroke={item[1].color}
                  dot={false}
                  activeDot={{ stroke: '#ffffff', strokeWidth: 2, r: 6 }}
                />
              );
            })}
          </LineChart>
        </ResponsiveContainer>
        <div className={css.legend}>
          {Object.entries(lines).map((item) => (
            <div key={item[0]}>
              <span style={{ backgroundColor: item[1].color }}></span>
              {item[1].label}
            </div>
          ))}
        </div>
      </SectionWrapper>
    </div>
  );
};

export default LineChartItem;
